import { forwardRef, type SelectHTMLAttributes } from 'react';
import { cx } from './utils';
import { FieldError } from './FieldError';

interface Props extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  error?: string;
  containerClassName?: string;
  options: readonly { value: string; label: string }[];
  placeholder?: string;
}

export const SelectField = forwardRef<HTMLSelectElement, Props>(
  ({ label, error, containerClassName, options, placeholder, className, ...rest }, ref) => (
    <div className={containerClassName}>
      {label && <label className="lbl">{label}</label>}
      <select
        ref={ref}
        {...rest}
        className={cx('inp cursor-pointer', error && 'inp-error', className)}
        aria-invalid={!!error}
      >
        {placeholder && <option value="">{placeholder}</option>}
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
      <FieldError message={error} />
    </div>
  ),
);
SelectField.displayName = 'SelectField';
